export const HEADING_VARIANTS = ['h0', 'h1', 'h2', 'h3', 'h4', 'h5'];

export const P_VARIANTS = [
  'caption1',
  'caption2',
  'caption3',
  'caption4',
  'caption5'
];
